import axios from 'axios';
import { getJWT } from 'src/helper/localStore/getJWT';
import { IsAuthorized } from 'src/authentication/IsAuthorized';

class HepstarAncillaryService {
  async getCountByStatus(status: string): Promise<number> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item-ancillaries/count`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: { status },
        }
      );

      return res.data?.count ?? res.data?.data?.count ?? res.data;
    } catch (error) {
      IsAuthorized(error);
      throw error;
    }
  }

  async updateStatus(ancillaryId: number, status: string): Promise<void> {
    try {
      await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item-ancillaries/${ancillaryId}/update-status`,
        { status },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      );
    } catch (error) {
      IsAuthorized(error);
      throw error;
    }
  }
}

export const hepstarAncillaryService = new HepstarAncillaryService();
